import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/enviodosdados',
      name: 'HelloWorld',
      component: () => import(/* webpackChunkName: "helloworld" */ '../components/HelloWorld.vue'),
      props: true
    },
    /*{
      path: '/enviodosdados2',
      name: 'HelloWorld2',
      component: () => import(/* webpackChunkName: "helloworld2" */ /*'../components/HelloWorld2.vue'),
      props: true
    },*/
    /*{
      path: '/enviodosdados3',
      name: 'HelloWorld_latam',
      component: () => import(/* webpackChunkName: "helloworld_latam" */ /*'../components/HelloWorld_latam.vue'),
      props: true
    },*/
    /*{
      path: '/664d453bck',
      name: 'LeituradeMapaQuiz',
      component: () => import(/* webpackChunkName: "leituramapa" */ /*'../components/LeituradeMapaQuiz.vue'),
    },*/
    {
      path: '/pGwZSDj',
      name: 'PaginaPrincipal',
      component: () => import(/* webpackChunkName: "paginaprincipal" */ '../components/PaginaPrincipal.vue'),
      props: true
    },
    /*{
      path: '/pGwZSDjL',
      name: 'PaginaPrincipalLatam',
      component: () => import(/* webpackChunkName: "paginaprincipal_latam" */  /*'../components/PaginaPrincipalLatam.vue'),
      props: true
    },
    {
      path: '/',
      name: 'KirvanoUpsellVideoCopy',
      component: () => import(/* webpackChunkName: "upsell_copy" */ /*'../components/KirvanoUpsellVideoCopy.vue'),
      props: false
    },*/
    {
      path: '/',
      name: 'KirvanoUpsellVideov2',
      component: () => import(/* webpackChunkName: "upsell_copy" */ '../components/KirvanoUpsellVideov2.vue'),
      props: false
    },
    /*{
      path: '/',
      name: 'KirvanoUpsellVideovLatam',
      component: () => import(/* webpackChunkName: "upsell_latam" */ /* '../components/KirvanoUpsellVideovLatam.vue'),
      props: false
    },/*
    {
      path: '/en',
      name: 'KirvanoUpsellVideovEN',
      component: () => import(/* webpackChunkName: "upsell_en" */ /*'../components/KirvanoUpsellVideovEN.vue'),
      props: false
    },*/
    /*{
      path: '/es',
      name: 'KirvanoUpsellVideovLatam',
      component: () => import(/* webpackChunkName: "upsell_latam" */ /*'../components/KirvanoUpsellVideovLatam.vue'),
      props: false
    },/*
    {
      path: '/gerador-cartilha',
      name: 'CartilhaPage',
      component: () => import(/* webpackChunkName: "cartilha" */ /*'../components/CartilhaPage.vue'),
      props: false
    },*/
    /*{
      path: '/firma-poder',
      name: 'AssinaturaPoderLatam',
      component: () => import(/* webpackChunkName: "firma_poder" */ /*'../components/AssinaturaPoderLatam.vue'),
      props: true
    },
    /*{
      path: '/g-firma',
      name: 'GerarAssinaturaLatam',
      component: () => import(/* webpackChunkName: "gerar_firma" */ /*'../components/GerarAssinaturaLatam.vue'),
      props: true
    }*/
  ],
});
